<form #form="ngForm">
    <div *ngIf="(formulaireAvanceService.paramAvance) as paramAvance; else loading">
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.avance.parametrage'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isActif"
                            name="isActif"
                            [ngModel]="paramAvance.actif"
                            [(customModel)]="paramAvance.actif"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.avance.actif"
                            postLibelle="admin.parametres.formulaire.avance.actifPost"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.avance.generalite'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isAvanceHorsOM"
                            name="isAvanceHorsOM"
                            [ngModel]="paramAvance.avanceHorsOM"
                            [(customModel)]="paramAvance.avanceHorsOM"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.avance.avanceHorsOM"
                            postLibelle="admin.parametres.formulaire.avance.avanceHorsOMPost"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isCalculPlafondAvance"
                            name="isCalculPlafondAvance"
                            [ngModel]="paramAvance.calculPlafondAvance"
                            [(customModel)]="paramAvance.calculPlafondAvance"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.avance.plafondOM"
                            postLibelle="admin.parametres.formulaire.avance.plafondOMPost"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="paramAvance.listeAvanceAuto[TypeAv.INDEMN_JOURNALIERE].pourcentage"
                            libelle="admin.parametres.formulaire.avance.indemnitesJournaliere"
                            name="indemnitesJournaliere"
                            [min]="0" [max]="100"
                            suffix="%"
                            [disabled]="!paramAvance.calculPlafondAvance"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            customType="multiselect"
                            name="tranchesHoraires"
                            libelle="admin.parametres.formulaire.avance.tranchesHoraires"
                            [placeholder]="'admin.parametres.formulaire.avance.tranchesHorairesListeTous' | translate"
                            [(ngModel)]="paramAvance.listeAvanceAutoFiltreIJ"
                            [selectOptions]="formulaireAvanceService.listeRegleAttributionOption"
                            optionDisplay="libelle"
                            optionValue="idRegleAttribution"
                            [disabled]="!paramAvance.calculPlafondAvance"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="paramAvance.listeAvanceAuto[TypeAv.FRAIS_PREV].pourcentage"
                            libelle="admin.parametres.formulaire.avance.fraisPrevisionnels"
                            name="fraisPrevisionnels"
                            [min]="0" [max]="100"
                            suffix="%"
                            [disabled]="!paramAvance.calculPlafondAvance"
                    ></custom-input>
                    <!--Prestations-->
                    <custom-input
                            ngDefaultControl
                            customType="multiselect"
                            name="prestations"
                            libelle="admin.parametres.formulaire.avance.prestations"
                            [placeholder]="'admin.parametres.formulaire.avance.prestationsListeTous' | translate"
                            [(ngModel)]="paramAvance.listeAvanceAutoFiltreFP"
                            [selectOptions]="formulaireAvanceService.listePrestationOption"
                            optionDisplay="libelle"
                            optionValue="idPrestation"
                            [disabled]="!paramAvance.calculPlafondAvance"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="paramAvance.listeAvanceAuto[TypeAv.FACT_PREV].pourcentage"
                            libelle="admin.parametres.formulaire.avance.propositionAgence"
                            name="propositionAgence"
                            [min]="0" [max]="100"
                            suffix="%"
                            [disabled]="!paramAvance.calculPlafondAvance"
                    ></custom-input>
                    <!--Natures-->
                    <custom-input
                            ngDefaultControl
                            customType="multiselect"
                            name="natures"
                            libelle="admin.parametres.formulaire.avance.natures"
                            [placeholder]="'admin.parametres.formulaire.avance.naturesListeTous' | translate"
                            [(ngModel)]="paramAvance.listeAvanceAutoFiltreFact"
                            [selectOptions]="listeOptionNature"
                            optionDisplay="libelle"
                            optionValue="typeFact"
                            [disabled]="!paramAvance.calculPlafondAvance"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="paramAvance.idStatutAvanceAutomatique"
                            [selectOptions]="formulaireAvanceService.listeStatutOption"
                            libelle="admin.parametres.formulaire.avance.statutAvanceAutomatique"
                            name="idStatutAvanceAutomatique"
                            optionDisplay="libelle"
                            optionValue="idStatut"
                            [disabled]="!paramAvance.calculPlafondAvance"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.avance.imputationAvances'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isImputationAvance"
                            name="isImputationAvance"
                            [ngModel]="paramAvance.imputationAvance"
                            [(customModel)]="paramAvance.imputationAvance"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.avance.activerImputation"
                            postLibelle="admin.parametres.formulaire.avance.activerImputationPost"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="isCloisonnementAvance"
                            name="isCloisonnementAvance"
                            [ngModel]="paramAvance.cloisonnementAvance"
                            [(customModel)]="paramAvance.cloisonnementAvance"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.avance.avancesOM"
                            postLibelle="admin.parametres.formulaire.avance.avancesOMPost"
                            [disabled]="!paramAvance.imputationAvance"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="isSelectionComptable"
                            name="isSelectionComptable"
                            [ngModel]="paramAvance.selectionComptable"
                            [(customModel)]="paramAvance.selectionComptable"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.avance.selectionnerImputation"
                            postLibelle="admin.parametres.formulaire.avance.selectionnerImputationPost"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            id="isMontantModifiable"
                            name="isMontantModifiable"
                            [ngModel]="paramAvance.montantModifiable"
                            [(customModel)]="paramAvance.montantModifiable"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.avance.modifierImputation"
                            postLibelle="admin.parametres.formulaire.avance.modifierImputationPost"
                    ></custom-input>
                </div>
                <div class="row">
                    <!--Mode de rapprochement des devises-->
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="paramAvance.modeRapprochementDevise"
                            [selectOptions]="listeModeRapprochementDeviseOption"
                            libelle="admin.parametres.formulaire.avance.rapprochementDevises"
                            name="modeRapprochementDevise"
                            optionDisplay="libelle"
                            optionValue="value"
                            [disabled]="!paramAvance.imputationAvance"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            customType="number"
                            [(ngModel)]="paramAvance.reculDateOctroi"
                            libelle="admin.parametres.formulaire.avance.clotureManuelle"
                            name="reculDateOctroi"
                            [min]="0"
                            [suffix]="'admin.parametres.formulaire.avance.clotureManuelleSuffix' | translate"
                            [disabled]="!paramAvance.imputationAvance"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="paramAvance.idStatutAvancePartielle"
                            [selectOptions]="formulaireAvanceService.listeStatutOption"
                            libelle="admin.parametres.formulaire.avance.statusPartiel"
                            name="idStatutAvancePartielle"
                            optionDisplay="libelle"
                            optionValue="idStatut"
                            [disabled]="!paramAvance.imputationAvance"
                    ></custom-input>
                    <custom-input
                            ngDefaultControl
                            customType="select"
                            [(ngModel)]="paramAvance.idStatutAvanceLettree"
                            [selectOptions]="formulaireAvanceService.listeStatutOption"
                            libelle="admin.parametres.formulaire.avance.statusLettrees"
                            name="idStatutAvanceLettree"
                            optionDisplay="libelle"
                            optionValue="idStatut"
                            [disabled]="!paramAvance.imputationAvance"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <floating-button [listeActions]="listeActions" [isPending]="formulaireAvanceService.isSaving"></floating-button>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>